module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7d580746844a0691ebbdd26ba5961c0e.png";